import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import AvpSaveFooter from "../shared/footer/AvpSaveFooter";
import BreadCrumb from "../shared/header/BreadCrumb";
import {
  userIsLogged,
  getRoute,
  apiGetAvpPlaylistContent,
  apiPostAvpPlaylistAddPlaylistContent,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import { findNode } from "./AvpGrafoUtil";
import { getValueByQueryString } from "../shared/manager/util";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneAvpContentPlaylistFileScreen() {
  const navigate = useNavigate();
  const { selectedLinguaTesto } = useLingueStore((state) => state);

  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);

  let breadCrumb = [
    {
      title: selectedLinguaTesto?.GestioneAvpContentPlaylistFileBreadcrumb1,
      link: "/avp",
    },
    {
      title: selectedLinguaTesto?.GestioneAvpContentPlaylistFileBreadcrumb2,
      link: null,
    },
    {
      title: selectedLinguaTesto?.GestioneAvpContentPlaylistFileBreadcrumb3,
      link: null,
    },
    {
      title: selectedLinguaTesto?.GestioneAvpContentPlaylistFileBreadcrumb4,
      link: null,
    },
  ];

  const [currentBreadCrumb, setCurrentBreadCrumb] = useState(breadCrumb);
  const [selectedPlaylistFile, setSelectedPlaylistFile] = useState(null);

  //FORM
  const formDurataInput = React.useRef();
  const formLoopCheckbox = React.useRef();
  const formRestartCheckbox = React.useRef();

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 20)) {
        navigate("/");
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    console.log("initPage");

    const idAvp = getValueByQueryString("idavp");
    const idNodo = getValueByQueryString("idnodo");
    breadCrumb[2].link = "/avp/grafo/" + idAvp + "?idnodo=" + idNodo;

    loadPlaylistFile();
  }

  function loadPlaylistFile() {
    const url = window.location.pathname;
    const idPlaylistFile = getValueByQueryString("idplaylistfile");

    if (idPlaylistFile != null && idPlaylistFile != "") {
      apiGetAvpPlaylistContent(idPlaylistFile, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setSelectedPlaylistFile(response.data);
        }
      });
    }
  }

  function validateForm() {
    console.log("validateForm");
    let valid = true;

    return valid;
  }

  function handleDurataChange(event) {
    let value = event.target.value;
    selectedPlaylistFile.durataVisualizzazione = parseInt(value);

    let newObj = Object.assign({}, selectedPlaylistFile);
    setSelectedPlaylistFile(newObj);
  }

  function handleUrlClick(event) {
    if (selectedPlaylistFile != null) {
      window.open(selectedPlaylistFile.urlFile, "_blank");
    }
  }

  function handleSettingsChange(event) {
    let value = event.target.value;
    selectedPlaylistFile.settings = value;

    let newObj = Object.assign({}, selectedPlaylistFile);
    setSelectedPlaylistFile(newObj);
  }

  function onLoopChange(event) {
    let value = event.target.checked;
    selectedPlaylistFile.loop = value;
    if (value) {
      selectedPlaylistFile.restartPlaylist = false;
    }
    let newObj = Object.assign({}, selectedPlaylistFile);
    setSelectedPlaylistFile(newObj);
  }

  function onRestartChange(event) {
    let value = event.target.checked;
    selectedPlaylistFile.restartPlaylist = value;
    if (value) {
      selectedPlaylistFile.loop = false;
    }
    let newObj = Object.assign({}, selectedPlaylistFile);
    setSelectedPlaylistFile(newObj);
  }

  function savePlaylistFile() {
    apiPostAvpPlaylistAddPlaylistContent(
      selectedPlaylistFile,
      function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setAlertSuccessOpen(true);
          setAlertErrorOpen(false);

          const idAvp = getValueByQueryString("idavp");
          const idNodo = getValueByQueryString("idnodo");
          const idLingua = getValueByQueryString("idlingua");
          navigate(
            "/avp/grafo/" +
              idAvp +
              "?idnodo=" +
              idNodo +
              "&idlingua=" +
              idLingua
          );
        } else {
          setAlertSuccessOpen(false);
          setAlertErrorOpen(true);
        }
      }
    );
  }

  function footerCancelCallback() {
    console.log("cancel");

    const idAvp = getValueByQueryString("idavp");
    const idNodo = getValueByQueryString("idnodo");
    const idLingua = getValueByQueryString("idlingua");
    navigate(
      "/avp/grafo/" + idAvp + "?idnodo=" + idNodo + "&idlingua=" + idLingua
    );
  }

  function footerSaveCallback() {
    console.log("save");

    if (validateForm()) {
      savePlaylistFile();
    }
  }

  return (
    <div id="avp-gestioneavp-screen">
      <AvpHeader selectedMenuId={"avp"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#playlistfile"} />
      <div id="avp-cms-screen-container">
        <Collapse in={alertSuccessOpen}>
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAvpContentPlaylistFileAlertSucess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAvpContentPlaylistFileAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-screen-content ">
          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-gestioneavp-nodearcs-section-title">
              {selectedLinguaTesto?.GestioneAvpContentPlaylistFileFormTitle}Gestione Playlist File
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-idplaylistfile" className="required">
                {selectedLinguaTesto?.GestioneAvpContentPlaylistFileFormIdPlaylist}ID Playlist
              </label>
              <br />
              <input
                id="avp-form-idplaylistfile"
                type="text"
                value={
                  selectedPlaylistFile != null
                    ? selectedPlaylistFile.idPlaylist
                    : ""
                }
                disabled={true}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-file" className="required">
                {selectedLinguaTesto?.GestioneAvpContentPlaylistFileFormFile}
              </label>
              <br />
              <input
                id="avp-form-file"
                type="text"
                value={
                  selectedPlaylistFile != null
                    ? selectedPlaylistFile.nomeFile
                    : ""
                }
                disabled={true}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div
              className="avp-cms-screen-content-column"
              style={{ width: "50%" }}
            >
              <label htmlFor="avp-form-descrizione" className="required">
                {selectedLinguaTesto?.GestioneAvpContentPlaylistFileFormDescription}
              </label>
              <br />
              <input
                id="avp-form-descrizione"
                type="text"
                style={{ maxWidth: "none" }}
                value={
                  selectedPlaylistFile != null
                    ? selectedPlaylistFile.descFile
                    : ""
                }
                disabled={true}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div
              className="avp-cms-screen-content-column"
              style={{ width: "50%" }}
            >
              <label htmlFor="avp-form-url" className="required">
                {selectedLinguaTesto?.GestioneAvpContentPlaylistFileFormUrl}
              </label>
              <br />
              <input
                id="avp-form-url"
                type="text"
                style={{ maxWidth: "none" }}
                value={
                  selectedPlaylistFile != null
                    ? selectedPlaylistFile.urlFile
                    : ""
                }
                disabled={true}
                onClick={handleUrlClick}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div
              className="avp-cms-screen-content-column"
              style={{ width: "50%" }}
            >
              <label htmlFor="avp-form-durata" className="required">
                {selectedLinguaTesto?.GestioneAvpContentPlaylistFileFormDuration}
              </label>
              <br />
              <input
                ref={formDurataInput}
                id="avp-form-durata"
                style={{ maxWidth: "none" }}
                type="number"
                min="0"
                value={
                  selectedPlaylistFile != null
                    ? selectedPlaylistFile.durataVisualizzazione
                    : "0"
                }
                onChange={handleDurataChange}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div
              className="avp-cms-screen-content-column"
              style={{ width: "50%" }}
            >
              <label htmlFor="avp-form-settings" className="required">
                {selectedLinguaTesto?.GestioneAvpContentPlaylistFileFormSettings}
              </label>
              <br />
              <input
                id="avp-form-settings"
                type="text"
                style={{ maxWidth: "none" }}
                value={
                  selectedPlaylistFile != null
                    ? selectedPlaylistFile.settings
                    : ""
                }
                onChange={handleSettingsChange}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <input
              id="avp-form-loop"
              ref={formLoopCheckbox}
              type="checkbox"
              onChange={onLoopChange}
              disabled={
                selectedPlaylistFile != null &&
                selectedPlaylistFile.restartPlaylist
                  ? "disabled"
                  : ""
              }
              checked={
                selectedPlaylistFile != null && selectedPlaylistFile.loop
                  ? "checked"
                  : ""
              }
            />
            <label for="avp-form-loop">{selectedLinguaTesto?.GestioneAvpContentPlaylistFileCheckboxLoop}</label>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <input
              id="avp-form-restart"
              ref={formRestartCheckbox}
              type="checkbox"
              onChange={onRestartChange}
              disabled={
                selectedPlaylistFile != null && selectedPlaylistFile.loop
                  ? "disabled"
                  : ""
              }
              checked={
                selectedPlaylistFile != null &&
                selectedPlaylistFile.restartPlaylist
                  ? "checked"
                  : ""
              }
            />
            <label for="avp-form-restart">{selectedLinguaTesto?.GestioneAvpContentPlaylistFileCheckboxRestartPlaylist}</label>
          </div>
        </div>
      </div>
      <AvpSaveFooter
        saveCallback={footerSaveCallback}
        cancelCallback={footerCancelCallback}
      />
    </div>
  );
}
